"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../../api");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ProjectRechargeRecordConfirm',
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      projectNumber: '',
      recordList: [],
      pendingResolve: null
    };
  },
  methods: {
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var params,
          projectNumber,
          res,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              params = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              projectNumber = String(params.projectNumber || '').trim();
              if (projectNumber) {
                _context.n = 1;
                break;
              }
              return _context.a(2, Promise.resolve(true));
            case 1:
              this.projectNumber = projectNumber;
              this.recordList = [];
              this.loading = true;
              _context.p = 2;
              _context.n = 3;
              return (0, _api.projectRechargeRecordListApi)({
                projectNumber: this.projectNumber,
                resubmitBatchId: params.resubmitBatchId
              });
            case 3:
              res = _context.v;
              this.recordList = this.normalizeRecordList(res);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.$message.error(_t && _t.message ? _t.message : '获取项目充值记录失败');
              return _context.a(2, false);
            case 5:
              _context.p = 5;
              this.loading = false;
              return _context.f(5);
            case 6:
              if (this.recordList.length) {
                _context.n = 7;
                break;
              }
              return _context.a(2, true);
            case 7:
              this.dialogVisible = true;
              return _context.a(2, new Promise(function (resolve) {
                _this.pendingResolve = resolve;
              }));
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function open() {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    normalizeRecordList: function normalizeRecordList(res) {
      var _this2 = this;
      var rawList = [];
      if (Array.isArray(res)) {
        rawList = res;
      } else if (res && Array.isArray(res.list)) {
        rawList = res.list;
      } else if (res && Array.isArray(res.records)) {
        rawList = res.records;
      }
      return rawList.map(function (item) {
        var typeName = item.typeName || item.operationTypeName || _this2.getTypeName(item.type);
        return {
          projectNumber: item.projectNumber || _this2.projectNumber,
          type: item.type,
          typeName: typeName,
          status: item.status,
          auditStatus: item.auditStatus,
          reason: item.reason || item.issueReason || item.releaseReason || '-',
          companyName: item.companyName || item.innerCompanyName || item.issueCompany || item.sendCompany || '-',
          relationCount: item.relationCount || item.empCount || item.issueQuantity || item.customerEmpCount || 0,
          operateTime: item.operateTime || item.createTime || item.updateTime || '-',
          operatorName: item.operatorName || item.operator || item.createBy || item.createName || '-'
        };
      });
    },
    getTypeName: function getTypeName(type) {
      var typeMap = {
        1: '发放',
        2: '回收'
      };
      return typeMap[type] || '-';
    },
    getTypeClass: function getTypeClass(row) {
      if (row.typeName === '回收' || Number(row.type) === 2) {
        return 'record-type-recycle';
      }
      if (row.typeName === '发放' || Number(row.type) === 1) {
        return 'record-type-grant';
      }
      return '';
    },
    getStatusName: function getStatusName(status) {
      var statusMap = {
        1: '已发放',
        2: '已回收',
        3: '待发放'
      };
      return statusMap[status] || '-';
    },
    getStatusClass: function getStatusClass(status) {
      var statusClassMap = {
        1: 'record-status-text--success',
        3: 'record-status-text--primary'
      };
      return statusClassMap[status] || 'record-status-text--info';
    },
    getAuditStatusName: function getAuditStatusName(auditStatus) {
      var auditStatusMap = {
        0: '待审核',
        1: '通过',
        2: '驳回',
        3: '无需审核'
      };
      return auditStatusMap[auditStatus] || '-';
    },
    getAuditStatusClass: function getAuditStatusClass(auditStatus) {
      var auditStatusClassMap = {
        0: 'record-status-text--primary',
        1: 'record-status-text--success',
        2: 'record-status-text--danger',
        3: 'record-status-text--info'
      };
      return auditStatusClassMap[auditStatus] || 'record-status-text--info';
    },
    handleConfirm: function handleConfirm() {
      this.resolveDialog(true);
    },
    handleCancel: function handleCancel() {
      this.resolveDialog(false);
    },
    resolveDialog: function resolveDialog(result) {
      var resolve = this.pendingResolve;
      this.pendingResolve = null;
      this.dialogVisible = false;
      if (resolve) {
        resolve(result);
      }
    }
  }
};